import { render, staticRenderFns } from "./messageSendManagement.vue?vue&type=template&id=838771b4&scoped=true&"
import script from "./messageSendManagement.vue?vue&type=script&lang=js&"
export * from "./messageSendManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838771b4",
  null
  
)

component.options.__file = "messageSendManagement.vue"
export default component.exports